module.exports = __webpack_public_path__ + "static/img/ios1.4.94c0e858.jpg";